import type { MFNamesKeys } from '../packages/config/MFNames';

type DevDeps = {
	[key in MFNamesKeys]?: MFNamesKeys[];
};
export const devDeps: DevDeps = {
	webStaticAdmin: [],
};
